import React, { useEffect, useState } from 'react';
import { Toolbar, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useGetList, useDataProvider, useNotify, useRefresh, useRedirect } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const TenantSelectorToolbar = () => {
  const [tenant, setTenant] = useState(() => sessionStorage.getItem('current-tenant') || 'all');
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh(); 
  
  const { data: tenants, isLoading, error } = useGetList(
    'tenant',
    { pagination: { page: 1, perPage: 100 }, sort: { field: 'name', order: 'ASC' } }
  );

  if (error) {
    notify('Error fetching tenants: ' + error.message);
  }

  useEffect(() => {
    
    const storedTenant = sessionStorage.getItem('current-tenant');

        // if there are tenants, no matching stored tenant, and only 1 tenant to choose, setTenant to that tenant
    if (!storedTenant && tenants && tenants.length === 1) {
      console.log('updating tenant to first in array, ', tenants[0].tenantId);
      updateTenant(tenants[0].tenantId);
    }
    // if there is a stored tenant that is the the tenants array, setTenant to match
    else if (storedTenant && tenants?.some(tenant => tenant.tenantId === storedTenant)) {
      console.log('updating tenant to matched item in array, ', storedTenant);
      console.log('tenants', tenants);
        setTenant(storedTenant);
    } 
    else if (!storedTenant) {
        setTenant('all');
    }
}, [tenants]);

  const handleTenantChange = (event) => {
    const newId = event.target.value;
    console.log('handleTenantChange', newId);
    updateTenant(newId);
  };

  const updateTenant = (tenantId:string) => {
    setTenant(tenantId);
    if (tenantId === 'all') {
      sessionStorage.removeItem('current-tenant');
      sessionStorage.removeItem('current-brand');
    } else {
      sessionStorage.setItem('current-tenant', tenantId);
      sessionStorage.removeItem('current-brand');
    }
    refresh();
  }


  // JK TODO - Other code is triggered by the state storage here, but generally removing the tenant selector from all views including MMAdmin
  /** Code that follows this will not run, removing the tenant selector from all views including MMAdmin */
  return <div/>;

  if (isLoading) return <div>Loading...</div>;
  if (!tenants) return null;
  if (tenants.length === 1) {
    console.log('only one tenant, no need to show selector');
     return <div/>;
  }

  const allTenantsOption = { tenantId: 'all', name: 'All Tenants' };
  const tenantsWithAllOption = [allTenantsOption, ...tenants];

  return (
    <div style={{ padding: 0 }}>
      <FormControl variant="filled" fullWidth style={{ margin:0 }}>
        <InputLabel id="tenant-select-label" style={{ color: 'white' }}>Tenant</InputLabel>
        <Select
          labelId="tenant-select-label"
          id="tenant-select"
          value={tenant}
          onChange={handleTenantChange}
          label="Tenant"
          style={{ color: 'white', width:"300px" }}
        >
          {tenantsWithAllOption.map((tenant) => (
            <MenuItem key={tenant.tenantId} value={tenant.tenantId}>
              {tenant.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TenantSelectorToolbar;